import type { IDepositStoreHeader } from "src/@types/deposit-reconciliation";

export function storeLabel({
  storeCode,
  storeName,
}: Pick<IDepositStoreHeader, "storeCode" | "storeName">): string {
  return storeName ? `${storeCode} — ${storeName}` : String(storeCode);
}
